<div class="position-relative mx-2" dropdown placement="bottom right">
  <button class="btn btn-light px-1 d-flew border flew-row align-items-center mh-names {{ menuClasses }}" dropdownToggle type="button">
    <i
      *ngIf="!me.avatar"
      class="p-1 me-1 material-icons md-24 rounded-circle fw-bold border border-3"
      data-cy="I-e309"
      [ngClass]="isWhite === false ? 'border-white text-white' : 'border-primary text-primary'"
      >perm_identity</i
    >
    <img *ngIf="me.avatar" class="user-avatar" src="{{ me.avatar }}" alt="" data-cy="I-e300987" />
    <span
      class="m-0 fw-semibold fs-7 fs--7 text-nowrap d-none d-sm-inline"
      *ngIf="me.lastname"
      [ngClass]="isWhite === false ? 'text-white' : ''"
      >{{ me.firstname }} {{ me.lastname }}</span
    >
    <span
      class="m-0 fw-semibold fs-7 text-nowrap d-none d-sm-inline"
      *ngIf="!me.lastname"
      [ngClass]="isWhite === false ? 'text-white' : ''"
      [translate]="'PRIVATE_SHARE.HEADER.UNKNOWN.USER'"
    ></span>
  </button>
  <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right user-menu" role="menu" aria-labelledby="button-basic">
    <li *ngFor="let item of items">
      <a href="javascript:void(0)" class="user-menu-item" (click)="action.emit(item)">
        <i *ngIf="item.icon" class="material-icons user-menu-icon">{{ item.icon }}</i>
        <img *ngIf="item.image" class="user-menu-icon" [src]="item.image" alt="" />
        {{ item.translate | translate }}
        <i class="material-icons user-menu-chevron">chevron_right</i>
      </a>
    </li>
  </ul>
</div>
